<template>
  <div class="MenuItem" :class="{ 'is-disabled': disabled }" @click="handleClick">
    <div v-if="$slots.prepend" class="MenuItem__prepend">
      <slot name="prepend"></slot>
    </div>
    <div class="MenuItem__content">
      <slot>
        <span v-if="title">{{ title }}</span>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title?: string
    disabled?: boolean
  }>(),
  {
    disabled: false,
  },
)

const emit = defineEmits<{
  click: [event: MouseEvent]
}>()

const handleClick = (event: MouseEvent) => {
  if (!props.disabled) {
    emit('click', event)
  }
}
</script>

<style scoped>
.MenuItem {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.15s;
  font-size: 0.875rem;
  color: rgb(var(--v-theme-main-black));
}

.MenuItem:hover:not(.is-disabled) {
  background-color: rgb(var(--v-theme-background));
}

.MenuItem.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.MenuItem__prepend {
  margin-right: 0.75rem;
  display: flex;
  align-items: center;
}

.MenuItem__content {
  flex: 1;
  display: flex;
  align-items: center;
}
</style>
